import {CodeReviewIcon} from '@primer/octicons-react'
import {ActionList, CounterLabel} from '@primer/react'
import {Link} from '@github-ui/react-router'
import type {CatchUpTimelineEvent} from '@github-ui/dotcom-schema/types/pull_requests/v1/activity'
import {useSuspenseActivityPageData} from '../../data/use-activity-page-data'
import {routeToConversationItem, useCurrentPathParams} from '../../data/use-comments-routing'
import {hasComments} from './activity-row-helpers'
import {reviewSummaryAnchor} from '../../../comments/utils/comment-anchors'
import {OVERVIEW_COMMENTS_ANCHOR_ID} from '../../../../helpers/constants'
import styles from '../ActivityRows.module.css'

export function ReviewCommentsRow() {
  const {summary} = useSuspenseActivityPageData()
  const pathParams = useCurrentPathParams()
  if (!hasComments(summary)) return null

  const n = summary?.comments?.count ?? 0
  // Review activity jumps to the latest review; issue-comment activity preserves oldest-first catch-up.
  const latest = summary?.comments?.events.reduce<CatchUpTimelineEvent | undefined>(
    (last, event) => (!last || Date.parse(event.timestamp) > Date.parse(last.timestamp) ? event : last),
    undefined,
  )
  const info = latest?.additionalInfo?.info
  const reviewId = info?.case === 'pullRequestReview' ? info.value.reviewId : undefined
  const hash = reviewId ? reviewSummaryAnchor(reviewId.toString()) : OVERVIEW_COMMENTS_ANCHOR_ID

  return (
    <ActionList.LinkItem as={Link} to={routeToConversationItem(pathParams, hash)} className={styles.labelRow}>
      <ActionList.LeadingVisual>
        <CodeReviewIcon />
      </ActionList.LeadingVisual>
      Review comments
      <ActionList.TrailingVisual className={styles.count}>
        <CounterLabel>{n}</CounterLabel>
      </ActionList.TrailingVisual>
    </ActionList.LinkItem>
  )
}
